export const ClassNameConstants = {
    Deleted: "-deleted",
    Hover: "-hover",
    Virtualized: "-virtualized",
};
